import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { NbAuthSocialLink, NB_AUTH_OPTIONS, getDeepFromObject } from '@nebular/auth';
import { URLConfig } from '../../../../configs/url-config';
import { ApiService } from '../../../services/api.service';
import { Validators, FormBuilder } from '@angular/forms';

@Component({
  selector: 'ngx-parent-login',
  templateUrl: './parent-login.component.html',
  styleUrls: ['./parent-login.component.scss']
})
export class ParentLoginComponent {
step: 'guardianEmail' | 'verifyGuardianOtp' = 'guardianEmail';
guardianToken:any=''
  guardianForm = this.fb.group({
    guardianEmail: ['', [Validators.required, Validators.email]],
  });

  otpForm = this.fb.group({
    otp: ['', [Validators.required]],
  });

  email = '';
  submitted = false;
  errors: string[] = [];
  messages: string[] = [];
  loading = false;
id:any
  constructor(
    private fb: FormBuilder,
    private api: ApiService,
    private router: Router,
    private cd: ChangeDetectorRef
  ) {}
sendGuardianOtp() {
  if (this.guardianForm.invalid) return;
  this.loading = true;
  this.errors = [];
  this.messages = [];

  this.email = this.guardianForm.value.guardianEmail!;
  const url = `${URLConfig.sendOtp}?email=${this.email}`;

  this.api.post(url, {}).subscribe({
    next: (res: any) => {
      this.id = res.data.id;
      this.guardianToken = res.data.token;
      this.api.success(res.message);
      this.step = 'verifyGuardianOtp';
      this.loading = false;
      this.cd.detectChanges();
    },
    error: () => {
      this.loading = false;
      this.errors = ['Failed to send OTP. Try again.'];
      this.cd.detectChanges();
    }
  });
}
verifyGuardianOtp() {
  if (this.otpForm.invalid) return;
  this.loading = true;
  this.errors = [];
  this.messages = [];
  const otp = this.otpForm.value.otp;
  const url = `${URLConfig.verifyGuardianOtp}?id=${this.id}&code=${otp}`;
  this.api.postWithoutInterceptor(url, {}, this.guardianToken).subscribe({
    next: (res: any) => {
      this.api.success(res.message);
        this.loading = false;
         const token = this.guardianToken;
      const id = this.id;
       
      this.router.navigate(['/guardian-students'], {
        queryParams: {
          id: this.id,
          token: token
        }
      });
      this.cd.detectChanges();
    },
    error: () => {
      this.loading = false;
      this.errors = ['Invalid OTP. Try again.'];
      this.cd.detectChanges();
    }
  });
}
}
